import { render, staticRenderFns } from "./TsMenuItem.vue?vue&type=template&id=744f0b10"
import script from "./TsMenuItem.vue?vue&type=script&lang=js"
export * from "./TsMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TsMenuItem.vue?vue&type=style&index=0&id=744f0b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports